import { z } from "zod";
import RemoteCollection from "../utility/remote-collection";

export const PasswordListItemSchema = z.unknown();
export const PasswordDetailItemSchema = z.unknown();
export const passwordCollection = new RemoteCollection("/api/account/self/user/self/password", PasswordListItemSchema, PasswordDetailItemSchema,);